<template>
  <base-table-component
    :title="title"
    :description="description"
    :rows="effectiveRows"
    :columns="columns"
    :summary-row="summaryRow"
  />
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { ITableColumn } from '@/utils/table'
import TableMixin from './mixins/TableMixin.vue'
import BaseTableComponent from './components/BaseTableComponent.vue'
import { MESSAGE_TYPE } from '@/utils/constants'

@Options({
  name: 'RichMenuTable',
  components: {
    BaseTableComponent,
  },
})
export default class RichMenuTable extends mixins(TableMixin) {
  protected getDefaultMessageType(): string {
    return MESSAGE_TYPE.RICH_MENU
  }

  get columns(): ITableColumn[] {
    return [...this.baseColumns, ...this.commonGoalColumns]
  }
}
</script>
